/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://0zkuvdcr36.execute-api.us-east-2.amazonaws.com/hyattpark",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://zkvh2de3tjhthnxojroldr57me.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-2jakrnf3yrfxfpabsghesr4zgi",
    "aws_cognito_identity_pool_id": "us-east-2:161d6a80-fdd4-4f3f-838e-3b842559f95b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_1a5CYX4f7",
    "aws_user_pools_web_client_id": "70tgam392jc3e1n500agfka9li",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
